import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, EventEmitter, Input, Output, signal } from '@angular/core';

import { AutoUnsubscribe } from '@app/shared/decorators/auto-unsubscribe.decorator';
@AutoUnsubscribe()
@Component({
    selector: 'app-button-slide',
    templateUrl: './button-slide.component.html',
    imports:[
      CommonModule
    ]
})
export class ButtonSlideComponent {
  @Output() isSubmitButtonActiveForSubMit: EventEmitter<string> = new EventEmitter();
  @Input() isDiscoveryContent: boolean = false;
  @Input() customTextSize = false;
  defaultSubmitButtonClass =
    'flex items-center bg-[#25508E] gap-1 p-4 border rounded-[8px] h-[64px] w-[204px] text-[#FFFFFF] uppercase m-w[420px] relative p-0 overflow-hidden text-base hover:bg-[#0D3672]';
  submitButtonClass =
    'flex items-center bg-[#EFFFF7] gap-1 p-4 border rounded-[8px] h-[64px] w-[204px] text-[#FFFFFF] uppercase m-w[420px] relative  p-0 border-[#1AA140] overflow-hidden text-base hover:bg-[#EFFFF7]';
  isSubmitButtonHover = false;
  isSubmitButtonClicked = false;
  showConfetti = signal(false);

  submit() {
    if (this.isDiscoveryContent) {
      this.isSubmitButtonActiveForSubMit.emit();
      return;
    }
    this.showAnimation();
  }

  showAnimation() {
    if (!this.isSubmitButtonClicked) {
      this.isSubmitButtonClicked = !this.isSubmitButtonClicked;
      this.isSubmitButtonHover = false;
      setTimeout(() => {
        this.showConfetti.set(true);
      }, 350);
      if (this.isSubmitButtonClicked) {
        setTimeout(() => {
          if (!this.isDiscoveryContent) {
            this.isSubmitButtonActiveForSubMit.emit('complete');
          }
        }, 600);
        setTimeout(() => {
          this.showConfetti.set(false);
        }, 3000);
      } else {
        if (!this.isDiscoveryContent) {
          this.isSubmitButtonActiveForSubMit.emit();
        }
      }
    }
  }
}
